.bv{flex-shrink:0;}